export default __webpack_public_path__ + "static/wechat_qr-9a41c9b4fcfdfb78ce5ce63501013532.png";